import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

import HomeLayout from '../views/home/HomeLayout'

/**
 * hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
 *                                if not set alwaysShow, only more than one route under the children
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
  }
 **/
export const constantRouterMap = [
  {path: '/user/profile', component: () => import('@/views/user/profile/index'), hidden: true},
  {
    path: '/',
    name: 'landing',
    component: () => import('@/views/landing/index'),
    hidden: true,
    meta: {title: 'route.landing'}
  },
  {
    path: '',
    component: HomeLayout,
    hidden: true,
    children: [{
      path: 'home',
      name: 'home',
      component: () => import('@/views/home/index'),
      meta: {title: 'route.home'}
    },
    {
      path: 'product/detail/:id',
      name: 'productDetail',
      component: () => import('@/views/product/detail'),
      meta: {title: 'route.productDetail'},
      hidden: true
    },
    {
      path: 'new-arrivals',
      name: 'newArrivals',
      component: () => import('@/views/home/index'),
      meta: {title: 'route.newArrivals'},
      hidden: true
    },
    {
      path: 'favorites',
      name: 'favorites',
      component: () => import('@/views/home/index'),
      meta: {title: 'route.favorites'},
      hidden: true
    }
    ]
  }
]

export const asyncRouterMap = []

export default new Router({
  // mode: 'history', //后端支持可开
  scrollBehavior: () => ({y: 0}),
  routes: constantRouterMap
})




// WEBPACK FOOTER //
// ./src/router/index.js